/**
 * Import Lib
 */

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import t from 'theme';


/**
 * import containers & components
 */


/**
 * styled components
 */

const Container = styled.div`
  background-color: transparent;
  max-width: ${t.grid.width};

  ${t.mixins.sm(`
    max-width: 100vw;
  `)}
`;


/**
   * Layout content is used for inner page content
   */

const Layout__content = ({ style, children }) => (
  <Container style={style}>
    {children}
  </Container>
);

Layout__content.propTypes = {
  /**
    A custom style object
    */
  children: PropTypes.node,
  /**
    A children object to render content inside the components
    */
  style: PropTypes.object,
};

Layout__content.defaultProps = {
  style: {},
  children: null,
};

export default Layout__content;
